<template>
  <div>
    <RankBar :chartData="chartData" id="homeyoukelaiyuan" />
  </div>
</template>

<script>
import RankBar from "@/components/Mycharts/RankBar.vue";

export default {
  name: "YoukeLaiyuanFenxi",
  components: {
    RankBar
  },
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
